import { Observable } from 'rxjs';

export class SideMenuItem {
  public titleKey: string;
  public mainIconClass: string;
  public route: string[];

  public children: SideMenuItem[] = [];
  public $isHidden?: Observable<boolean>;
  public isExpanded?: boolean;

  public constructor(partial: Partial<SideMenuItem>) {
    Object.assign(this, partial);
  }
}
